import { styled } from '@tigergraph/app-ui-lib/Theme';

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
});

export const ChildPage = styled('div', {
  flexBasis: 0,
  flexGrow: 1,
});

export const Form = styled('form', {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const FormContentContainer = styled('div', {
  display: 'flex',
  flexBasis: 0,
  flexGrow: 1,
  overflowY: 'auto',
});

export const FormContent = styled('div', {
  margin: '0 auto',
  maxWidth: '1200px',
  padding: '16px',
});

export const FormControllerContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const Desc = styled('div', ({ $theme }) => ({
  ...$theme.typography.Label,
  color: '#656565',
  marginTop: '-8px',
}));
